var _mask, _path, _g, _path2, _path3, _g2, _path4, _mask2, _path5, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportSince = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 501,
    height: 501,
    viewBox: "0 0 501 501",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1434_2608",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.041 357.345C286.85 364.155 286.901 375.275 279.434 381.357C257.079 399.564 230.406 411.892 201.851 417.063C167.556 423.273 132.183 418.864 100.462 404.427C68.7402 389.99 42.1828 366.212 24.3409 336.272C6.49902 306.333 -1.77684 271.66 0.620045 236.891C3.01694 202.121 15.9723 168.912 37.7537 141.704C59.535 114.496 89.104 94.5872 122.506 84.6392C155.909 74.6912 191.552 75.1785 224.67 86.0358C252.246 95.0761 276.976 110.947 296.62 132.05C303.182 139.099 301.606 150.107 293.926 155.917L187.32 236.581C178.882 242.966 178.029 255.334 185.512 262.816L280.041 357.345Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280.041 357.345C286.85 364.155 286.901 375.275 279.434 381.357C257.079 399.564 230.406 411.892 201.851 417.063C167.556 423.273 132.183 418.864 100.462 404.427C68.7402 389.99 42.1828 366.212 24.3409 336.272C6.49902 306.333 -1.77684 271.66 0.620045 236.891C3.01694 202.121 15.9723 168.912 37.7537 141.704C59.535 114.496 89.104 94.5872 122.506 84.6392C155.909 74.6912 191.552 75.1785 224.67 86.0358C252.246 95.0761 276.976 110.947 296.62 132.05C303.182 139.099 301.606 150.107 293.926 155.917L187.32 236.581C178.882 242.966 178.029 255.334 185.512 262.816L280.041 357.345Z",
    fill: "#ADB6C5",
    stroke: "black",
    strokeWidth: 34.0633,
    mask: "url(#path-1-inside-1_1434_2608)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1434_2608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.979 28.2146C179.979 23.5369 183.771 19.7448 188.448 19.7448L392.202 19.7422C394.416 19.7422 396.542 20.6091 398.125 22.1572L476.247 98.5734C477.876 100.167 478.794 102.349 478.794 104.628V472.819C478.794 477.497 475.002 481.289 470.325 481.289H188.448C183.771 481.289 179.979 477.497 179.979 472.819V28.2146Z",
    fill: "#ADB6C5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M392.202 11.2264L188.448 11.229C179.067 11.2291 171.463 18.8337 171.463 28.2146V472.819C171.463 482.2 179.067 489.805 188.448 489.805H470.324C479.705 489.805 487.31 482.2 487.31 472.819V104.628C487.31 100.058 485.469 95.6812 482.202 92.4857L404.079 16.0695C400.905 12.9648 396.642 11.2264 392.202 11.2264Z",
    stroke: "black",
    strokeWidth: 17.0316,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M395.941 100.617V12.2794C395.941 11.5518 396.825 11.1923 397.333 11.7133L483.424 100.051C483.925 100.564 483.561 101.428 482.843 101.428H396.752C396.305 101.428 395.941 101.065 395.941 100.617Z",
    fill: "#060F1F",
    stroke: "black",
    strokeWidth: 15.8151
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1434_2608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.191 216.121V51.4634C209.191 51.0155 209.558 50.6521 210.006 50.6544C298.344 51.0931 371.086 122.691 371.507 216.116C371.509 216.564 371.146 216.932 370.698 216.932H210.002C209.555 216.932 209.191 216.569 209.191 216.121Z",
    fill: "#060F1F"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M209.191 216.121V51.4634C209.191 51.0155 209.558 50.6521 210.006 50.6544C298.344 51.0931 371.086 122.691 371.507 216.116C371.509 216.564 371.146 216.932 370.698 216.932H210.002C209.555 216.932 209.191 216.569 209.191 216.121Z",
    stroke: "black",
    strokeWidth: 15.4096
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_1434_2608",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.497 248.66C342.497 284.096 331.497 318.658 311.016 347.576C290.535 376.493 261.583 398.34 228.156 410.101C194.729 421.862 158.475 422.956 124.399 413.234C90.3233 403.511 60.1057 383.45 37.9175 355.821L171.356 248.66H342.497Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M342.497 248.66C342.497 284.096 331.497 318.658 311.016 347.576C290.535 376.493 261.583 398.34 228.156 410.101C194.729 421.862 158.475 422.956 124.399 413.234C90.3233 403.511 60.1057 383.45 37.9175 355.821L171.356 248.66H342.497Z",
    fill: "#060F1F",
    stroke: "black",
    strokeWidth: 34.0633,
    mask: "url(#path-6-inside-2_1434_2608)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 364.291,
    y: 19.7422,
    width: 23.6241,
    height: 21.3085,
    fill: "#ADB6C5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1434_2608",
    x: 162.947,
    y: 2.71094,
    width: 332.879,
    height: 495.609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -43.3901,
    dy: 2.02758
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.534407 0 0 0 0 0.565238 0 0 0 0 0.616623 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1434_2608"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1434_2608",
    x: 201.486,
    y: 42.9492,
    width: 177.727,
    height: 181.688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -31.2247,
    dy: 10.5434
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1434_2608"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportSince);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reportSince.3ce20d2f7fd24c6d764703ed0981a64b.svg";